import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumList',
    standalone: false
})
export class EnumList implements PipeTransform {
    public transform(value: any, args?: any[]): any {
        const items: any[] = [];

        for (const key of Object.keys(value)) {
            const isValueProperty = parseInt(key, 10) >= 0;
            if (isValueProperty) {
                items.push({ key: key, value: value[key] });
            }
        }

        return items;
    }
}
